import React, { useEffect, useRef, useState } from "react";

import toast, { Toaster } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import arrowUp from "../../Assets/Icons/arrow_up.png";
import arrowDown from "../../Assets/Icons/arrow_down.png";
import "./Shop.css";
import { showAuth } from "../../Redux/action";

import Products from "./Products";
import apiRequest from "../../apiCall";
import config from "../../Admin/Config.json";
import ReactHtmlParser from "react-html-parser";
import ReactStars from "react-rating-stars-component";
import { setLoading } from "../../Redux/action";
import { setCart } from "../../Redux/action";


const UserShop = () => {
  document.title = "ZeroZero";
  const [product, setProduct] = useState(null);
  const [ItemSize, setSelectedSize] = useState();
  const [ItemPrice, setSelectedPrice] = useState();
  const [UOMValue, setSelectedUOMValue] = useState();
  const [mlIndex, setMlIndex] = useState(0);
  const [sizes, setSizes] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [imageHeight, setImageHeight] = useState(0);
  const [productImages, setProductImages] = useState([]);
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const selectedSize =
    sizes && mlIndex >= 0 && mlIndex < sizes.length ? sizes[mlIndex] : null;

  const [selectedItem, setSelectedItem] = useState(0);
  const mainImageRef = useRef();
  const dispatch = useDispatch();

  const storedData = localStorage.getItem("userData") || " {}";
  const userData = JSON.parse(storedData);
  const userId = userData.id || null;
  const CustomerId = userData.id || null;

  const navigation = useLocation();
  const { id } = useParams();

  useEffect(() => {
    apiRequest(
      "GET",
      "shop/product-detail/" + id.replaceAll("-", " "),
      null,
      false,
      false
    )
      .then((res) => {
        dispatch(setLoading(true));
        if (res?.itemId > 0) {
          const fetchedImages = res?.slider?.map(
            (x) => config.awsMediaPath + x
          );
          setProductImages(fetchedImages);
          setProduct(res);
          setSizes(res.units);
          setSelectedItem(0);
          window.scrollTo(0, 0);
          setQuantity(1);
          setCurrentIndex(0);
          setSelectedSize(res.units[0].packSize);
          setSelectedPrice(res.units[0].price);
          setSelectedUOMValue(res.units[0].UOMValue);
          setTab(0);
          setReviewsData([]);
        }
        dispatch(setLoading(false));
      })
      .catch(function (error) {
        console.error(error);
        dispatch(setLoading(false));
      });
  }, [navigation]);

  useEffect(() => {
    changeImageHeight();
    window.addEventListener("resize", changeImageHeight);
    return () => {
      window.removeEventListener("resize", changeImageHeight);
    };
  }, []);

  const changeImageHeight = () => {
    if (mainImageRef.current) {
      mainImageRef.current.style.height =
        mainImageRef.current.offsetWidth * 1.001 + "px";
      const imgs = document.getElementsByClassName("imgs");
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].style.height = mainImageRef.current.offsetWidth / 5 - 10 + "px";
        imgs[i].style.width = mainImageRef.current.offsetWidth / 6 + "px";
        document.querySelector(".images").style.width =
          mainImageRef.current.offsetWidth / 6 + "px";
      }
    }
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % productImages.length);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [productImages]);

  const handleUp = () => {
    setCurrentIndex(
      currentIndex > 0 ? currentIndex - 1 : productImages.length - 1
    );
  };

  const handleDown = () => {
    setCurrentIndex((currentIndex + 1) % productImages.length);
  };

  const handleQuantityAdd = () => {
    setQuantity(quantity + 1);
  };

  const handleQuantitySubtract = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  // const price = (product ? product.price : null) * (mlIndex + 1);

  // const errors = () => toast.error("Please Login.");
  const sucsess = () => toast.success("Added to cart");

  const handleAddToCart = async () => {
    if (userId == null) {
      dispatch(showAuth(true));
    } else if (selectedSize) {
      const { itemId, PTR, packLabel, UOM, price, packSize } = selectedSize;
      const { productCode, heading } = product;

      const requestData = {
        heading,
        itemId,
        packLabel,
        ItemSize,
        quantity,
        ItemPrice,
        PTR,
        UOM,
        UOMValue,
        productCode,
        CustomerId,
      };

      try {
        const response = await apiRequest(
          "POST",
          `cart/${productCode}/${packLabel}`,
          requestData,
          false,
          false
        );

        if (response.action === "add") {
          setIsAddedToCart(true);
          sucsess();
          dispatch(setCart(true));
        } else if (response.action === "update") {
          dispatch(setCart(true));
          toast.success("Cart Updated");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      // Handle case when no size is selected
    }
  };

  const handleImageClick = (index) => {
    setCurrentIndex(index);
  };

  window.addEventListener("resize", changeImageHeight);

  const [tab, setTab] = useState(0);

  const [showReviewForm, setShowReviewForm] = useState(false);
  const [reviewsData, setReviewsData] = useState([]);
  const navigate = useNavigate();

  const fetchReviews = async () => {
    try {
      apiRequest(
        "GET",
        "shopproductreviews/" + product.productCode,
        {},
        false,
        false
      )
        .then((res) => {
          if (res?.length > 0) {
            setReviewsData(res);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    } catch (error) {
      console.error("Error fetching reviews:", error);
      // Handle error if necessary
    }
  };
  useEffect(() => {
    if (tab) {
      fetchReviews();
    }
  }, [tab]);

  const toggleReviewForm = () => {
    setShowReviewForm(!showReviewForm);
  };

  const calculateOverallRating = () => {
    if (reviewsData.length === 0) {
      return 0;
    }

    const totalRatings = reviewsData.reduce(
      (sum, review) => sum + parseInt(review.Rating),
      0
    );
    return totalRatings / reviewsData.length;
  };

  return (
    <div className="shop">
      <div className="product">
        <section id="ls">
          <div className="images">
            <img src={arrowUp} id="up" onClick={handleUp} />
            <img src={arrowDown} id="down" onClick={handleDown} />
            {productImages.map((image, idx) => (
              <img
                className={idx === currentIndex ? "imgs active" : "imgs"}
                key={idx}
                src={image}
                alt={`img${idx}`}
                onClick={() => handleImageClick(idx)}
              />
            ))}
          </div>
          <img
            src={productImages[currentIndex]}
            className="main-image"
            style={{ height: imageHeight }}
            ref={mainImageRef}
          />
        </section>

        <section id="rs">
          <h2>{product ? product.heading : null}</h2>
          <div className="price">
            <span>
              <h3>
                {sizes && sizes.length > 0
                  ? "₹" + sizes[selectedItem]?.price
                  : ""}
              </h3>
            </span>
            {/* <span id='real-price'>{'₹' + (170 * (mlIndex + 1)) + '.00'}</span> */}
            <span id="discount"></span>
          </div>
          <div className="tax">Tax included.</div>
          <h3 style={{fontSize:'20px'}}>About product</h3>
          <p className="product-about-us"> {product ? ReactHtmlParser(product.aboutProduct) : null}</p>
          {selectedSize && (
            <div className="size">
              <h3>Unit</h3>
              <br />
              <div className="sizes">
                {sizes.map((item, index) => (
                  <span
                    className={selectedItem === index ? "ml active" : "ml"}
                    onClick={() => {
                      setSelectedItem(index);
                      setSelectedSize(item.packSize);
                      setSelectedPrice(item.price);
                      setSelectedUOMValue(item.UOMValue);
                      setQuantity(1);
                    }}
                  >
                    {item.packLabel}
                  </span>
                ))}
              </div>
            </div>
          )}
          <h3>Quantity</h3>
          <div className="purchase">
            <div className="quantity">
              <span onClick={handleQuantitySubtract}>─</span>
              {quantity}
              <span style={{ fontWeight: "bold" }} onClick={handleQuantityAdd}>
                +
              </span>
            </div>
            <div className="add-to-cart" onClick={handleAddToCart}>
              Add to cart
            </div>
            {/* <Link style={{ textDecoration: "none" }} to="/shop/cart" className="buy-now">
              Buy From Nearby Pharmacy
            </Link> */}
          </div>
          <div className="note-to-cusomer">
            <p>
              Please note: ZeroZero will not be directly sending the product it
              will be delivered by the nearest pharmacy
            </p>
          </div>
        </section>
      </div>

      <Products
        excludeId={id}
        redirect={(pathname) => {
          navigate(pathname);
        }}
      />
      <Toaster position="top-right" />

      <div className="tab-view">
        <section className="first">
          <div className="tabs">
            <span
              onClick={() => setTab(0)}
              className={tab === 0 ? "active" : null}
            >
              Product Details
            </span>
            <span
              onClick={() => setTab(1)}
              className={tab === 1 ? "active" : null}
            >
              Reviews
            </span>
            {/* <span onClick={() => setTab(2)} className={tab === 2 ? 'active' : null}>Shipping and Return</span> */}
          </div>
        </section>
        <section className="review-section">
          <div className="content">
            {tab === 0 && (
              <div>
                <div>{product && ReactHtmlParser(product.productDetails)}</div>
                <div className="images">
                  <div>
                    {product &&
                      product.detailsImages &&
                      product.detailsImages.map((item, index) => (
                        <div className="shop-last-div">
                          <img
                            className="shop-last"
                            key={index}
                            src={config.awsMediaPath + item}
                            alt={`img${index}`}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
            {tab === 1 && (
              <div className="reviews-div">
                <div className="product-review-div">
                  <p>
                    <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                      {calculateOverallRating().toFixed(1)}/5
                    </span>{" "}
                    Overall rating
                  </p>
                  <button className="review-button" onClick={toggleReviewForm}>
                    <span>Write Review</span>
                  </button>
                </div>
                {showReviewForm ? (
                  <ReviewForm
                    onClose={() => setShowReviewForm(false)}
                    productId={product.productCode}
                  />
                ) : (
                  Array.isArray(reviewsData) &&
                  reviewsData
                    .filter((item) => item.Status === "Published")
                    .map((item) => (
                      <div className="review" key={item.ID}>
                        <h3 className="fullname">{item.FullName}</h3>
                        <ReactStars
                          value={parseInt(item.Rating)}
                          activeColor="#FAAF00"
                          numberOfStars={5}
                          name="rating"
                          starDimension={20}
                          starSpacing={1.5}
                          size={30}
                        />
                        <p className="product-review">{item.Review}</p>
                      </div>
                    ))
                )}
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

const ReviewForm = ({ onClose, productId }) => {
  const dispatch = useDispatch();
  const [reviewData, setReviewData] = useState({
    reviewText: "",
    rating: 0,
  });
  const errors = () => toast.error("Please Login.");
  const rating = () => toast.error("Please Give rating.");
  const datasave = () => toast.success("Thank You for your valuable Rating!");

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userid = userData ? userData.id : null;
  const email = userData ? userData.email : null;

  const handleReviewTextChange = (event) => {
    const text = event.target.value;
    const wordCount = text.split(/\s+/).length;
    if (wordCount > 100) {
      toast.error("You have reached the maximum words limit.");
      return;
    }
    setReviewData({ ...reviewData, reviewText: text });
  };

  const handleRatingChange = (newRating) => {
    setReviewData({ ...reviewData, rating: newRating });
  };

  const submitReview = async () => {
    if (reviewData.rating < 1 || reviewData.rating > 5) {
      rating();
      return;
    }

    if (!userid) {
      errors();
      dispatch(showAuth(true));
      return;
    }

    const reviewPayload = {
      productId: productId,
      reviewText: reviewData.reviewText,
      rating: reviewData.rating,
      userid: userid,
      email: email,
    };

    try {
      dispatch(setLoading(true));
      // Send the reviewPayload to the backend API using async/await
      apiRequest("POST", "shop/productreview", reviewPayload, null, null);

      // Handle the response if needed.
      dispatch(setLoading(false));
      datasave();
      onClose();
    } catch (error) {
      console.error("Error saving review:", error);
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="review-form-container">
      {/* ... Add your review form elements here ... */}
      <div className="review-form">
        <textarea
          type="text"
          className="review-form-textarea"
          placeholder="Write Review"
          value={reviewData.reviewText}
          onChange={handleReviewTextChange}
        />
        <ReactStars
          rating={reviewData.rating}
          className="star-rating"
          activeColor="#FAAF00"
          onChange={handleRatingChange}
          count={5}
          name="rating"
          size={30}
          starDimension={25}
          starSpacing={1.5}
        />
        <div className="review-form-buttons-div">
          <button onClick={submitReview} className="review-form-submit-button">
            Post
          </button>
          &nbsp;&nbsp;
          <button onClick={onClose} className="review-form-cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserShop;
